// Static content data for Medskinby landing page

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1595182281528-5ceaa7765993?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHw0fHxoZWFsdGh5JTIwZ2xvd2luZyUyMHNraW4lMjB3b21hbiUyMG1pbmltYWwlMjBwb3J0cmFpdCUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzc4Njc0NjQzfDA&ixlib=rb-4.1.0&q=85",
  about: "https://images.unsplash.com/photo-1668989956626-5b633e36ee27?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBza2luY2FyZSUyMGNsaW5pYyUyMHNwYSUyMG1pbmltYWwlMjBpbnRlcmlvcnxlbnwwfHx8fDE3Nzg2NzQ2NDN8MA&ixlib=rb-4.1.0&q=85",
  treatmentsAbstract: "https://images.unsplash.com/photo-1714636608872-048fc9231892?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxza2luY2FyZSUyMGNyZWFtJTIwdGV4dHVyZSUyMGFic3RyYWN0JTIwbWluaW1hbGlzdHxlbnwwfHx8fDE3Nzg2NzQ2NDN8MA&ixlib=rb-4.1.0&q=85",
  products: "https://images.unsplash.com/photo-1777730611102-766b6e5ec3cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxib3R0bGVzJTIwb2YlMjBsdXh1cnklMjBza2luJTIwc2VydW0lMjBtaW5pbWFsaXN0JTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3Nzg2NzQ2NTF8MA&ixlib=rb-4.1.0&q=85",
  beforeAfter: "https://images.unsplash.com/photo-1710580889701-9fa8f2cd5927?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMHNraW4lMjB0ZXh0dXJlJTIwbWFjcm8lMjBwaG90b2dyYXBoeSUyMG5ldXRyYWx8ZW58MHx8fHwxNzc4Njc0NjUxfDA&ixlib=rb-4.1.0&q=85",
  testimonialAvatars: [
    "https://images.unsplash.com/photo-1713442861325-8ac2038d3cb5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxoZWFsdGh5JTIwZ2xvd2luZyUyMHNraW4lMjB3b21hbiUyMG1pbmltYWwlMjBwb3J0cmFpdCUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzc4Njc0NjQzfDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1728848901352-cff8d51d3e24?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxoZWFsdGh5JTIwZ2xvd2luZyUyMHNraW4lMjB3b21hbiUyMG1pbmltYWwlMjBwb3J0cmFpdCUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzc4Njc0NjQzfDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1713207524097-596f3c17afc3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHxoZWFsdGh5JTIwZ2xvd2luZyUyMHNraW4lMjB3b21hbiUyMG1pbmltYWwlMjBwb3J0cmFpdCUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzc4Njc0NjQzfDA&ixlib=rb-4.1.0&q=85",
  ],
};

export const TREATMENTS = [
  {
    id: "akne",
    pillarSlug: "akne-arr-uren-hud",
    title: "Akne & uren hud",
    description: "Målrettet behandling som adresserer årsakene bak utbrudd – fra hormoner til mikrobiom og inflammasjon.",
  },
  {
    id: "sensitiv",
    pillarSlug: "sensitiv-hud",
    title: "Sensitiv hud",
    description: "Skånsomme, kliniske protokoller for reaktiv hud som trenger ro, beskyttelse og styrking.",
  },
  {
    id: "rosacea",
    pillarSlug: "rosacea-inflammasjon",
    title: "Rosacea & inflammasjon",
    description: "Roer ned vedvarende rødme og inflammatoriske responser med dokumenterte aktive ingredienser.",
  },
  {
    id: "barriere",
    pillarSlug: "hudbarriere",
    title: "Hudbarriere",
    description: "Gjenoppbygger og forsterker hudens forsvar – nøkkelen til langvarig hudhelse.",
  },
  {
    id: "hormonell",
    pillarSlug: "hormonell-ubalanse",
    title: "Hormonell ubalanse",
    description: "Helhetlig kartlegging og behandling av hud påvirket av sykluser, stress og hormonelle skift.",
  },
  {
    id: "anti-age",
    pillarSlug: "anti-age-hudfornyelse",
    title: "Anti-age & hudfornyelse",
    description: "Preventive og regenererende protokoller for fasthet, glød og fornyet hudstruktur.",
  },
];

export const WHY_US = [
  {
    title: "Klinisk ekspertise",
    description: "Medisinsk faglig forankring i hver vurdering og hver behandling.",
  },
  {
    title: "Helhetlig tilnærming",
    description: "Vi behandler huden i sammenheng med livsstil, hormoner og indre balanse.",
  },
  {
    title: "Personlig behandlingsplan",
    description: "Skreddersydde protokoller bygget rundt din hud, ditt mål og din rytme.",
  },
  {
    title: "Varige resultater",
    description: "Vi jobber langsiktig – ikke med raske fix, men med synlig, vedvarende endring.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Ingrid H.",
    location: "Oslo",
    quote: "Etter mange år med inflammert hud opplever jeg endelig ro. Den faglige forståelsen og den varme tilnærmingen er noe helt for seg selv.",
    rating: 5,
  },
  {
    name: "Mari S.",
    location: "Oslo",
    quote: "Medskinby har snudd hudreisen min. Behandlingsplanen er skreddersydd og resultatene har vart.",
    rating: 5,
  },
  {
    name: "Anders B.",
    location: "Oslo",
    quote: "Profesjonelt, presist og diskret. Klinikken har et nivå du sjelden finner i Norge.",
    rating: 5,
  },
];
